type WalkTreeArgs<T> = {
  node: T;
  childAccessor: (node: T) => T[];
  callback: (node: T) => void;
  skipChildren?: (node: T) => boolean;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const walkTree = <T extends Record<string, any>>({
  node,
  skipChildren,
  callback,
  childAccessor = (args) => args.nodes,
}: WalkTreeArgs<T>) => {
  if (!node) {
    return;
  }
  callback(node);

  if (
    skipChildren &&
    typeof skipChildren === "function" &&
    skipChildren(node)
  ) {
    return;
  }
  const nodes = childAccessor(node);
  if (nodes) {
    nodes.forEach((n) => {
      walkTree({ node: n, childAccessor, callback, skipChildren });
    });
  }
};
